// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hn-6";
export var emphasizeQuantity = "_hn-3";
export var flatBottomCorners = "_hn-5";
export var productImage = "_hn-0";
export var quantityContainer = "_hn-2";
export var tooltip = "_hn-1";
export var wrapAndEllipsesOverflow = "_hn-4";